import * as Sentry from "@sentry/react";
import { getPdfjs } from "./pdfjs";

const PDF_MIME_TYPE = "application/pdf";

export const getPageCountForFile = async (file: File): Promise<number> => {
  if (file.type !== PDF_MIME_TYPE) {
    return 1;
  }

  try {
    const pdfjs = getPdfjs();

    const pdf = await pdfjs.getDocument(URL.createObjectURL(file)).promise;
    const numPages = pdf.numPages;

    if (!numPages) {
      Sentry.captureMessage("PDF page count returned invalid value", {
        level: "error",
        tags: { errorType: "pdf-page-count" },
        extra: {
          fileName: file.name,
          fileSize: file.size,
          numPages,
        },
      });
      return 1;
    }

    return numPages;
  } catch (error) {
    Sentry.captureException(error, {
      tags: { errorType: "pdf-page-count" },
      extra: {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
      },
    });
    return 1;
  }
};
